import React, { useState, useContext } from "react";
import "./collage-row.scss";
import { GatsbyImage } from "gatsby-plugin-image";
import { findRel } from "../../../shared/utils/stringUtilities";
import { normalizeTwoWords } from "../../../shared/utils/stringUtilities";
import GlobalContext from "../../../contexts/globalContext";
import Button from "../button/button";

const CollageRow = (props: CollageRowInterface) => {
  const { card1, card2, card3, hasButton } = props;

  const [leftExpanded, setLeftExpanded] = useState(false);
  const [midExpanded, setMidExpanded] = useState(false);
  const [rightExpanded, setRightExpanded] = useState(true);

  const isHttp = (url?: string) => {
    return url?.startsWith("http");
  };

  const togleExpansion = (col) => {
    if (col == "left" && !leftExpanded) {
      setLeftExpanded(true);
      setMidExpanded(false);
      setRightExpanded(false);
    }
    if (col === "mid" && !midExpanded) {
      setLeftExpanded(false);
      setMidExpanded(true);
      setRightExpanded(false);
    }
    if (col === "right" && !rightExpanded) {
      setLeftExpanded(false);
      setMidExpanded(false);
      setRightExpanded(true);
    }
  };

  const dataContext = useContext(GlobalContext);

  const setGmt = (contenido) => {
    if (
      dataContext.userInfoContext.data?.userHaveTransaction ||
      dataContext.userInfoContext.data?.userHaveTransaction != undefined
    ) {
      return `gtmRedDeAmorSesionIniciadaContenidosNuestraRed${normalizeTwoWords(
        contenido
      )}`;
    } else {
      return `gtmRedDeAmorContenidosNuestraRed${normalizeTwoWords(contenido)}`;
    }
  };

  return (
    <div className="a-collage-row">
      <div
        className={`a-collage-row__left${leftExpanded ? "-expanded" : ""}`}
        onMouseEnter={() => togleExpansion("left")}
      >
        <GatsbyImage
          className="a-collage-img"
          image={card1?.url}
          alt={card1?.title}
        />
        <div className="information">
          <h3>{card1?.title}</h3>
          <p className={`${!leftExpanded ? "hidden" : ""}`}>
            {card1?.information}
          </p>
        </div>
        <div className="gradient" />
        <a
          className={`a-collage-card-link ${setGmt(card1?.title)}`}
          href={card1?.redirect}
          rel={findRel(card1?.redirect)}
          target={isHttp(card1?.redirect) ? "_blank" : "_self"}
        ></a>
        {card1?.costless_chip ? (
          <div className="chip">
            <p>Sin Cobro</p>
          </div>
        ) : null}
      </div>

      <div
        className={`a-collage-row__mid${midExpanded ? "-expanded" : ""}`}
        onMouseEnter={() => togleExpansion("mid")}
      >
        <GatsbyImage
          className="a-collage-img"
          image={card2?.url}
          alt={card2?.title}
        />
        <div className="information">
          <h3>{card2?.title}</h3>
          <p className={`${!midExpanded ? "hidden" : ""}`}>
            {card2?.information}
          </p>
        </div>
        <div className="gradient" />
        <a
          className={`a-collage-card-link ${setGmt(card2?.title)}`}
          href={card2?.redirect}
          rel={findRel(card2?.redirect)}
          target={isHttp(card2?.redirect) ? "_blank" : "_self"}
        ></a>
        {card2?.costless_chip ? (
          <div className="chip">
            <p>Sin Cobro</p>
          </div>
        ) : null}
      </div>
      {hasButton ? (
        <div
          className={`a-collage-row__show-card a-collage-row__right${
            rightExpanded ? "-expanded" : ""
          }`}
          onMouseEnter={() => togleExpansion("right")}
        >
          <div className="a-collage-row__show-card__container">
            <p className="a-collage-row__show-card__container__text">
              {card3?.title}
            </p>
            {/*            <Link
              rel={findRel(card3.redirect)}
              target={isHttp(card3.redirect) ? "_blank" : "_self"}
              to={card3.redirect}
              className={`a-collage-row__show-card__container__button ${setGmt(
                card3.tituloBoton
              )}`}
            >
              <p>{card3.tituloBoton}</p>
            </Link> */}
            <Button
              text={card3?.tituloBoton}
              classname={
                "a-button  transparent a-collage-row__show-card__container__button l-large"
              }
              type={"link"}
              isDisabled={false}
              strictCss={false}
              gtmMark={setGmt(card3?.tituloBoton)}
              href={card3?.redirect}
            />
          </div>
        </div>
      ) : (
        <div
          className={`a-collage-row__right${rightExpanded ? "-expanded" : ""}`}
          onMouseEnter={() => togleExpansion("right")}
        >
          <GatsbyImage
            className="a-collage-img"
            image={card3?.url}
            alt={card3?.title}
          />
          <div className="information">
            <h3>{card3?.title}</h3>
            <p className={`${!rightExpanded ? "hidden" : ""}`}>
              {card3?.information}
            </p>
          </div>
          <div className="gradient" />
          <a
            className={`a-collage-card-link ${setGmt(card3?.title)}`}
            href={card3?.redirect}
            rel={findRel(card3?.redirect)}
            target={isHttp(card2?.redirect) ? "_blank" : "_self"}
          ></a>
          {card3?.costless_chip ? (
            <div className="chip">
              <p>Sin Cobro</p>
            </div>
          ) : null}
        </div>
      )}
    </div>
  );
};

interface CollageRowInterface {
  card1: any;
  card2: any;
  card3?: any;
  hasButton: boolean;
}

export default CollageRow;
